import type { JSX } from 'react';

import { Grid } from '@change/ds-layout';

import { PageBanner } from '../components/PageBanner';
import { PageBody } from '../components/PageBody';
import { PageFooter } from '../components/PageFooter';
import { PageHeading } from '../components/PageHeading';
import { PageMeta } from '../components/PageMeta';

import { useTrackPageView } from './hooks/useTrackPageView';

export function Layout(): JSX.Element {
	useTrackPageView();

	return (
		<>
			<PageMeta />
			<PageBanner />
			<Grid className="mt-4 px-0 pb-4 lg:max-w-[1216px] lg:!grid-cols-[repeat(14,minmax(0,1fr))]">
				<div className="col-span-full">
					<PageHeading />
					<PageBody />
				</div>
			</Grid>
			<PageFooter />
		</>
	);
}
